import { useUpdateProfile } from "react-firebase-hooks/auth";
import { Link } from "react-router-dom";
import FirebaseError from "../components/FirebaseError";
import SpinnerBorder from "../components/SpinnerBorder";
import auth from "../firebase/auth";

function Label({ label }) {
  return (
    <label class="label">
      <span class="label-text after:content-['*'] after:ml-0.5 after:text-red-500">
        {label}
      </span>
    </label>
  );
}

export default function RegisterForm({
  createUserWithEmailAndPassword,
  creatingUserWithEmailAndPassword,
  accountCreationError,
}) {
  const [updateProfile] = useUpdateProfile(auth);

  const handleRegister = async (event) => {
    event.preventDefault();

    const { name, email, password } = Object.fromEntries(
      new FormData(event.target).entries()
    );

    await createUserWithEmailAndPassword(email, password);

    await updateProfile({ displayName: name });
  };

  return (
    <>
      <h1 class="text-5xl font-bold mb-6">Register now!</h1>

      <div class="card flex-shrink-0 w-full max-w-sm mx-auto shadow-2xl bg-base-100">
        <form onSubmit={handleRegister} class="card-body">
          <div class="form-control">
            <Label label="Email" />

            <input
              type="text"
              name="email"
              placeholder="email"
              class="input input-bordered"
            />
          </div>

          <div class="form-control">
            <Label label="Name" />

            <input
              type="text"
              name="name"
              placeholder="name"
              class="input input-bordered"
            />
          </div>

          <div class="form-control">
            <Label label="Password" />

            <input
              type="password"
              name="password"
              placeholder="password"
              class="input input-bordered"
              autoComplete="new-password"
            />
          </div>

          <div class="form-control">
            <label class="label">
              <Link
                to="/login"
                class="label-text-alt link link-hover hover:!text-blue-500"
              >
                Have an account?
              </Link>
            </label>

            <button class="btn btn-primary">
              {creatingUserWithEmailAndPassword ? (
                <SpinnerBorder />
              ) : (
                <>Register</>
              )}
            </button>

            {accountCreationError && (
              <FirebaseError error={accountCreationError} />
            )}
          </div>
        </form>
      </div>
    </>
  );
}
